// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2144":"63e6b4e8","3843":"52973f2c","4550":"fd584acd"}[chunkId] + ".chunk.css";
};